import {Component, OnInit} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams} from 'ionic-angular';
import {StorageService} from "../../providers/storage";
import {SocialService} from "../../providers/social-service";
import {TwitterKeywordForm} from "../twitter-keyword-form/twitter-keyword-form";

@Component({
  selector: 'page-twitter-settings-keywords',
  templateUrl: 'twitter-settings-keywords.html',
})
export class TwitterSettingsKeywords implements OnInit {
  keywords = [];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private storageService: StorageService,
              private socialService: SocialService,
              private _modal: ModalController,
              private alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad TwitterSettingsKeywords');
  }

  ngOnInit() {
    this.loadKeywords();
  }

  updateKeyword(k) {
    this.socialService.updateKeyword(k).subscribe(
      (data) => {
        // console.log(data);
      },
      (err) => {
        // console.log(err);
      }
    )
    return true;
  }

  addKeyword() {
    let myModal = this._modal.create(TwitterKeywordForm, {k: null});
    myModal.onDidDismiss((data) => {
      if (data !== null) {
        this.socialService.addKeyword(data).subscribe(
          (data) => {
            // console.log(data);
            this.loadKeywords();
          },
          (err) => {
            // console.log(err);
          },
          () => {
          }
        )
      }
    });
    myModal.present();
  }

  editKeyword(k) {
    let myModal = this._modal.create(TwitterKeywordForm, {k: k});
    myModal.onDidDismiss((data) => {
      if (data !== null) {

        this.socialService.updateKeyword(data).subscribe(
          (data) => {
            // console.log(data);
            this.loadKeywords();
          },
          (err) => {
            // console.log(err);
          },
          () => {
          }
        )
      }
    });
    myModal.present();
  }

  loadKeywords() {
    this.socialService.getKeywords().subscribe(
      (data) => {
        this.keywords = data;
      },
      (err) => {
        // console.log(err)
      },
      () => {

      }
    )
  }

  deleteKeyword(k) {
    // event.stopPropagation();

    let confirm = this.alertCtrl.create({
      title: 'Sei sicuro?',
      message: 'Confermi l\'eliminazione della keyword?',
      buttons: [
        {
          text: 'Annulla',
          handler: () => {
            // console.log('Disagree clicked');
          }
        },
        {
          text: 'Elimina',
          handler: () => {
            // console.log('Agree clicked');
            this.socialService.deleteKeyword(k.id).subscribe(
              () => {
                this.loadKeywords();
              },
              err => console.log(err)
            )
          }
        }
      ]
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/twitter-settings-keywords/twitter-settings-keywords.ts